export enum Population {
    User,
    Team,
    Lob,
    Region,
    Area,
    Site,
    SuperGroup,
    PeerGroup,
    Role,
    Queue,
    PopulationGroup,
}
